<template>
  <div class="container-current-topics">
    <div>
      <div class="container-current-topics-title">
        <img src="/chat.svg" alt="chat" />
        <span class="current-topics-title"> Assuntos do momento </span>
      </div>
    </div>
    <CustomSkeleton
      v-if="isSearching"
      :listWidth="{ firstLine: '400px', secondLine: '300px' }"
      :listHeight="{ thirdLine: '100px' }"
      type="list"
    />

    <span v-if="biggestTrends.length === 0 && !isSearching" class="no-data-text">
      Não há assuntos do momento nessa data.
    </span>
    <Listbox
      v-if="!isSearching"
      :options="biggestTrends"
      option-label="title"
      list-style="max-height:400px;padding-right: 15px;"
    >
      <template #option="slotProps">
        <div class="current-topics-list-content">
          <span class="current-topics-list-name">{{ slotProps.option.title }}</span>
        </div>
      </template>
    </Listbox>
  </div>
</template>

<script>
import Listbox from 'primevue/listbox'
import CustomSkeleton from '@/Shared/CustomSkeleton'

export default {
  props: {
    isSearching: Boolean,
    biggestTrends: Array,
  },
  components: {
    Listbox,
    CustomSkeleton,
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
